import { Fragment, FunctionalComponent, h } from 'preact';

interface LoadMoreProps {
  response: any;
  count: number;
  loading: boolean;
  handleGetMore: (
    e: any
  ) => Promise<{
    data: any;
    error: any;
  }>;
}

export const LoadMore: FunctionalComponent<LoadMoreProps> = ({ response, handleGetMore, count, loading }) => (
  <Fragment>
    {count > 1 && response?.total_pages >= 2 && (
      <div className="product-list__footer">
        <div className="pagination">
          <div className="pagination__text">
            Showing {count} of {response.total}
          </div>
          <span className="pagination__indicator">
            <span
              className="pagination__indicator__bar"
              style={{ width: `${(response.page / response.total_pages) * 100}%` }}
            />
          </span>

          {response.page < response.total_pages && (
            <button
              type="button"
              className={`button button--outline pagination__action ${loading ? 'is-loading' : ''}`}
              onClick={(e) => handleGetMore(e)}
              data-test="load-more-btn"
            >
              <span className="button__label  ">Load more</span>
              <svg aria-hidden="true" width={6} height={8} xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.49 3.575L2.09.176a.597.597 0 00-.846 0L.679.741a.597.597 0 000 .847L3.085 4 .676 6.41a.597.597 0 000 .846l.565.568a.597.597 0 00.847 0l3.4-3.4a.598.598 0 00.002-.849z"
                  fill="currentColor"
                  fillRule="evenodd"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    )}
  </Fragment>
);
